import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import toast from "react-hot-toast";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import useTokenStore from "store/tokenStore";

const useResolveGiftRecipientByEmail = () => {
	const { accessToken } = useTokenStore();
	const history = useHistory();

	const resolveRecipient = async (query) => {
		const instance = await InitApi({ accessToken });
		const response = await instance.post("users/resolve-by-email", { query });
		return response.data?.data ?? null;
	};

	return useMutation(resolveRecipient, {
		onError: async (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{
					className: "max-w-max",
				}
			);

			if (error?.response?.data?.message === "Unauthenticated.") {
				reactLocalStorage.clear();
				history.push("/");
			}
		},
	});
};

export default useResolveGiftRecipientByEmail;
